export const timezones = [
  { name: 'America/Argentina/Buenos_Aires', label: 'Argentina', flag: '🇦🇷' },
  { name: 'America/La_Paz', label: 'Bolivia', flag: '🇧🇴' },
  { name: 'America/Sao_Paulo', label: 'Brasil', flag: '🇧🇷' },
  { name: 'America/Santiago', label: 'Chile', flag: '🇨🇱' },
  { name: 'America/Bogota', label: 'Colombia', flag: '🇨🇴' },
  { name: 'America/Costa_Rica', label: 'Costa Rica', flag: '🇨🇷' },
  { name: 'America/Havana', label: 'Cuba', flag: '🇨🇺' },
  { name: 'America/Guayaquil', label: 'Ecuador', flag: '🇪🇨' },
  { name: 'America/El_Salvador', label: 'El Salvador', flag: '🇸🇻' },
  { name: 'Europe/Madrid', label: 'España', flag: '🇪🇸' },
  { name: 'America/Guatemala', label: 'Guatemala', flag: '🇬🇹' },
  { name: 'America/Tegucigalpa', label: 'Honduras', flag: '🇭🇳' },
  { name: 'America/Mexico_City', label: 'México', flag: '🇲🇽' },
  { name: 'America/Managua', label: 'Nicaragua', flag: '🇳🇮' },
  { name: 'America/Panama', label: 'Panamá', flag: '🇵🇦' },
  { name: 'America/Asuncion', label: 'Paraguay', flag: '🇵🇾' },
  { name: 'America/Lima', label: 'Perú', flag: '🇵🇪' },
  { name: 'America/Puerto_Rico', label: 'Puerto Rico', flag: '🇵🇷' },
  { name: 'America/Santo_Domingo', label: 'República Dominicana', flag: '🇩🇴' },
  { name: 'America/Montevideo', label: 'Uruguay', flag: '🇺🇾' },
  { name: 'America/Chicago', label: 'USA (Central)', flag: '🇺🇸' },
  { name: 'America/New_York', label: 'USA (Este)', flag: '🇺🇸' },
  { name: 'America/Los_Angeles', label: 'USA (Pacífico)', flag: '🇺🇸' },
  { name: 'America/Caracas', label: 'Venezuela', flag: '🇻🇪' },
];
